import type { CSSProperties, MouseEventHandler, ReactNode } from "react"
import { useI18n } from "@/i18n"

const APP_URL = import.meta.env.VITE_APP_URL || "http://localhost:3000"

export type AppLinkProps = {
  href: string
  children: ReactNode
  className?: string
  style?: CSSProperties
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

/**
 * Link component that points to the main Tessel app (apps/web)
 * Use this for login, signup, and other app-specific routes
 * Automatically passes language param when not pt-br
 */
export const AppLink = ({
  href,
  children,
  className,
  style,
  onClick,
}: AppLinkProps) => {
  const { language } = useI18n()

  // Build URL with language param if not pt-br
  const buildHref = () => {
    const url = new URL(href, APP_URL)
    if (language !== "pt-br") {
      url.searchParams.set("lang", language)
    }
    return url.toString()
  }

  return (
    <a href={buildHref()} className={className} style={style} onClick={onClick}>
      {children}
    </a>
  )
}
